(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Report", [], factory);
	else if(typeof exports === 'object')
		exports["Report"] = factory();
	else
		root["Report"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 